import { renderBoolean } from './renderBoolean';
import { renderDate } from './renderDate';
import { renderItAccreditationStatus } from './renderItAccreditationStatus';
import { renderSubjectId } from './renderSubjectId';

export const getSubjectHistoryFields = (name: string) => ({
  [`/${name}/ogrn`]: {
    name: 'Основной государственный регистрационный номер (ОГРН)',
    active: true,
  },
  [`/${name}/inn`]: {
    name: 'Идентификационный номер налогоплательщика (ИНН)',
    active: true,
  },
  [`/${name}/organizationName`]: {
    name: 'Наименование проверяемого лица',
    active: true,
  },
  [`/${name}/organizationName/fio`]: {
    name: 'Фамилия, имя, отчество (при наличии)',
    active: true,
  },
  [`/${name}/isSonko`]: {
    name: 'Наличие контролируемого лица в реестре СОНКО',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/nkoForeignAgentsRegistryNumber`]: {
    name: 'Регистрационный номер в реестре НКО-иноагентов',
    active: true,
  },
  [`/${name}/nkoForeignAgentsRegistryInclusionDate`]: {
    name: 'Дата включения в реестр НКО иноагентов',
    active: true,
  },
  [`/${name}/nkoForeignAgentsRegistryExclusionDate`]: {
    name: 'Дата исключения в реестр НКО иноагентов',
    active: true,
  },
  [`/${name}/locationAddress`]: {
    name: 'Адрес места нахождения',
    active: true,
  },
  [`/${name}/workAddress`]: {
    name: 'Место нахождения (осуществления деятельности) контролируемого лица',
    active: true,
  },
  [`/${name}/factualAddress`]: {
    name: 'Место фактического осуществления деятельности',
    active: true,
  },
  [`/${name}/snils`]: {
    name: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
    active: true,
  },
  [`/${name}/document`]: {
    name: 'Сведения о документе, удостоверяющем личность',
    active: true,
  },
  [`/${name}/mspCode`]: {
    name: 'Категория субъекта МСП',
    active: true,
  },
  [`/${name}/country`]: {
    name: 'Государство, в котором указанное юридическое лицо зарегистрировано',
    active: true,
  },
  [`/${name}/{id}`]: {
    name: 'ОКВЭД',
    active: true,
    renderFunc: renderSubjectId,
  },
  [`/${name}/okveds/{id}/name`]: {
    name: 'Наименование ОКВЭД',
    active: true,
  },
  [`/${name}/okveds/{id}/code`]: {
    name: 'Номер ОКВЭД',
    active: true,
  },
  [`/${name}/isPresentInItRegistry`]: {
    name: 'Наличие в реестре аккредитованных IT-организаций',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/subjectType/title`]: {
    name: 'Тип контролируемого лица',
    active: true,
  },
  [`/${name}/itAccreditationResponse/registryNumber`]: {
    name: 'Регистрационный номер',
    active: true,
  },
  [`/${name}/itAccreditationResponse/dateDecisionAccreditation`]: {
    name: 'Дата включения',
    active: true,
    renderFunc: renderDate,
  },
  [`/${name}/itAccreditationResponse/organizationStatus`]: {
    name: 'Статус',
    active: true,
    renderFunc: renderItAccreditationStatus,
  },
  [`/${name}/rafpNza`]: {
    name: 'Номер записи об аккредитации в РАФП',
    active: true,
  },
  [`/${name}/kpp`]: {
    name: 'Код причины постановки на учет (КПП)',
    active: true,
  },
});
